import React, { useState, useEffect } from 'react'
import './AnimatedLinesBackground.css'

const AnimatedLinesBackground = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Detect mobile devices
    const checkMobile = () => {
      const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
                     window.innerWidth < 768
      setIsMobile(mobile)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Reduce line count on mobile for better performance
  const lineCount = isMobile ? 10 : 30

  return (
    <div className={`animated-lines-background ${isMobile ? 'mobile-optimized' : ''}`}>
      <div className="lines">
        {Array.from({ length: lineCount }).map((_, i) => (
          <div key={i} className="line"></div>
        ))}
      </div>
    </div>
  )
}

export default AnimatedLinesBackground
